import { registerPlugin } from '@capacitor/core';

/**
 * Native-Plugin `AppFlags` der Android-Hülle (docs/android-app-vertrag.md,
 * Schnittstelle „Native-Plugin AppFlags", Paket A).
 *
 * EINE Registrierung für alle Aufrufer (nativeShims.ts: `drucken`,
 * dateiAusgabe.ts: `emailEntwurf`). Capacitor nimmt denselben Namen kein zweites Mal an: der zweite
 * `registerPlugin`-Aufruf warnt nur („already registered. Cannot register
 * plugins twice.") und liefert den ersten Proxy zurück.
 *
 * Registriert wird erst beim ersten Zugriff — keine Last beim Start, im
 * Browser nie. Ob die installierte APK das Plugin überhaupt kennt, prüfen die
 * Aufrufer vorher mit `hatPlugin('AppFlags')` (ältere APKs haben es nicht).
 */
export interface AppFlagsPlugin {
  /** Android PrintManager über webView.createPrintDocumentAdapter (wie window.print, @media print gilt). */
  drucken(opts?: { titel?: string }): Promise<void>;
  /**
   * EIN Mail-Entwurf mit Empfängern, Betreff, Text und Anhang (Vertrag E19):
   * Android ACTION_SEND mit EXTRA_EMAIL/CC/SUBJECT/TEXT, EXTRA_STREAM über
   * FileProvider, Chooser. `dateiUri` = von Filesystem.writeFile gelieferte
   * Uri im Cache (`dateiInCacheSchreiben`). Ältere APKs kennen die Methode
   * nicht — Aufruf lehnt dann ab; Rückfall in `mailEntwurfMitDatei`.
   */
  emailEntwurf(opts: { an: string[]; cc?: string[]; betreff: string; text: string; dateiUri?: string }): Promise<void>;
}

let plugin: AppFlagsPlugin | null = null;

/** Das Plugin — beim ersten Aufruf registriert, danach immer derselbe Proxy. */
export function appFlags(): AppFlagsPlugin {
  if (!plugin) plugin = registerPlugin<AppFlagsPlugin>('AppFlags');
  return plugin;
}
